module.exports = __webpack_public_path__ + "static/xk-bab9140c008bfdd4f90e1b7e45709257.svg";